"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconButtonStyles = void 0;

var _styleHelpers = require("../styleHelpers");

var iconButtonStyles = {
  size: {
    small: '24px',
    medium: '32px',
    large: '40px'
  },
  icon: {
    scale: 1,
    transition: [['transform', '0.2s']],
    active: {
      scale: 0.833333333
    },
    size: {
      small: '20px',
      medium: '28px',
      large: '36px'
    }
  },
  borderRadius: '6px',
  plain: {
    backgroundColor: 'transparent',
    color: (0, _styleHelpers.getColor)('common', 'black'),
    active: {
      backgroundColor: (0, _styleHelpers.getColor)('brand'),
      color: (0, _styleHelpers.getColor)('common', 'white')
    },
    hover: {
      backgroundColor: (0, _styleHelpers.getColor)('blackOpacity', '50'),
      color: (0, _styleHelpers.getColor)('common', 'black')
    },
    focus: {
      backgroundColor: (0, _styleHelpers.getColor)('blackOpacity', '100'),
      color: (0, _styleHelpers.getColor)('common', 'black')
    }
  },
  brand: getIconButtonColorConfig('brand', (0, _styleHelpers.getColor)('common', 'white')),
  positive: getIconButtonColorConfig('positive', (0, _styleHelpers.getColor)('common', 'white')),
  negative: getIconButtonColorConfig('negative', (0, _styleHelpers.getColor)('common', 'white')),
  transition: [['background-color', '0.2s'], ['color', '0.2s']],
  disabled: {
    opacity: 0.3
  }
};
exports.iconButtonStyles = iconButtonStyles;

function getIconButtonColorConfig(colorName, contrastColor) {
  return {
    backgroundColor: 'transparent',
    color: (0, _styleHelpers.getColor)(colorName),
    active: {
      backgroundColor: (0, _styleHelpers.getColor)(colorName),
      color: contrastColor
    },
    hover: {
      backgroundColor: (0, _styleHelpers.getColor)(colorName, 'lightest'),
      color: (0, _styleHelpers.getColor)(colorName, 'dark')
    },
    focus: {
      backgroundColor: (0, _styleHelpers.getColor)(colorName, 'light'),
      color: (0, _styleHelpers.getColor)(colorName, 'dark')
    }
  };
}